import React,{useState} from 'react'
import { NavLink } from 'react-router-dom';
import "./style/nav-style.css";

const Navbar = () => {
  let [alt, setAlt] = useState(false)
  const openOverlay=(e)=>{
    setAlt(!alt)
  }
  return (
  <>
  <div className="nav">
    <div className="bg"></div>
     <div className="insideBox">
        <div className="one">  <img src="./assets/Group 2.svg" alt="" className="logo" />
    </div>
        <div className="two">
        <hr />
        <ul>
            <li><NavLink to='/'><span className="number">00. </span>HOME</NavLink></li>
            <li><NavLink to='/destination'><span className="number">01. </span>DESTINATION </NavLink></li>
            <li><NavLink to='/crew'><span className="number">02. </span>CREW</NavLink></li>
            <li><NavLink to='/technology'><span className="number">03. </span>TECHNOLOGY</NavLink></li>
        </ul>
        </div>
       <div className="burger" onClick={openOverlay}>
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
       </div>

      
       
     </div>
  </div>

  <div className="overlay" id={alt?"overlay-open":""}>
<div className="crossbox">
  <div className="innercross" onClick={openOverlay}>
  <img src="./assets/Group.svg" alt="" />
  </div>

</div>
<ul id="list">
<li><span className="number">00. </span><NavLink to='/'>HOME</NavLink></li>
            <li><span className="number">01. </span><NavLink to='/destination'>DESTINATION </NavLink></li>
            <li><span className="number">02. </span><NavLink to='/crew'>CREW</NavLink></li>
            <li><span className="number">03. </span><NavLink to='/technology'>Technology</NavLink></li>
        </ul>
  </div>
  </>
  )
}

export default Navbar